import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MdArrowDropDown, MdGroup, MdMenuBook, } from 'react-icons/md';
import axios from 'axios';
import { web_url } from '../../constant';
import Select from 'react-select';
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";


const url = "http://localhost:8080/api/";
function StudentSignUp2() {
    const [language, setLanguage] = useState(() => {
        const languageNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return languageNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const [openRequestSendingAlert, setOpenRequestSendingAlert] = useState(false);

    const handleClickOpenRequestSendingAlert = () => {
        setOpenRequestSendingAlert(true);
    };


    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [studentSignupDetails, setstudentSignupDetails] = useState(
        {
            school: '',
            grade: '',
            class: '',
            teacher: '',
            languagePrefer: '',
            actors: [],
            hobbies: [],
            movies: [],
            sports: []
        }
    )

    useEffect(() => {
        localStorage.removeItem('studentsignup2');
    }, [])

    const [errors, setErrors] = useState(
        {
            noSchool: false,
            noGrade: false,
            noClass: false,
            noTeacher: false,
            noLanguage: false,
            noActors: false,
            noMovies: false,
            noSports: false,
            noHobbies: false
        }
    )

    const options = [
        { label: 'Favourite actors', value: 'Actor' },
        { label: 'Favourite hobbies', value: 'Hobbies' },
        { label: 'Favourite movies', value: 'Movies' },
        { label: 'Favourite sports', value: 'Sports' },
    ];

    const [optionsVisible, setOptionsVisible] = useState({
        Actors: false,
        Quote: false,
        Movies: false,
        Sports: false,
        Hobbies: false,
        noFavourites: false
    })

    const [selectedOptions, setSelectedOptions] = useState([]);

    const handleChange = (selected) => {
        setSelectedOptions(selected);

        const updatedVisibility = {
            Actors: selected.some(option => option.value === 'Actor'),
            Movies: selected.some(option => option.value === 'Movies'),
            Sports: selected.some(option => option.value === 'Sports'),
            Hobbies: selected.some(option => option.value === 'Hobbies'),
        };

        setOptionsVisible(updatedVisibility);
    };

    const handleChangeHobby = (event, newValue, reason) => {
        // Allow removing at any time
        if (reason === 'removeOption' || newValue.length <= 2) {
            setstudentSignupDetails((prev) => ({ ...prev, hobbies: newValue }));
        }
    };

    const handleChangeSports = (event, newValue, reason) => {
        // Allow up to 2 selections only
        if (reason === 'removeOption' || newValue.length <= 2) {
            setstudentSignupDetails((prev) => ({ ...prev, sports: newValue }))
        }
    };

    const handleChangeActor = (event, newValue, reason) => {
        // Allow up to 2 selections only
        if (reason === 'removeOption' || newValue.length <= 2) {
            setstudentSignupDetails((prev) => ({ ...prev, actors: newValue }))
        }
    };

    const handleChangeMovie = (event, newValue, reason) => {
        // Allow up to 2 selections only
        if (reason === 'removeOption' || newValue.length <= 2) {
            setstudentSignupDetails((prev) => ({ ...prev, movies: newValue }))
        }
    };

    const [schoolFetchError, setSchoolFetchError] = useState('');
    const [schoolObjectArray, setSchoolObjectArray] = useState([]);
    const [schoolIndexSelected, setSchoolIndexSelected] = useState(0);


    const [openEmptyArray, setOpenEmptyArray] = useState(false);

    const handleClickOpenEmptyArray = () => {
        setOpenEmptyArray(true);
    };

    const handleCloseEmptyArray = () => {
        setOpenEmptyArray(false);
        navigate('/registerasstudent')
    };

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            localStorage.removeItem('studentsignup1')
            localStorage.removeItem('studentsignup2')
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    const [disabled, setIsDisabled] = useState(false);

    useEffect(() => {
        if (localStorage.getItem('userStatusDetails')) {


            const userStatusDetails = JSON.parse(localStorage.getItem('userStatusDetails'));
            const newDetails = {
                // school: "richmond",
                school: userStatusDetails.school,
                grade: userStatusDetails.grade,
                class: userStatusDetails.class,
                teacher: userStatusDetails.tName,
                languagePrefer: "",
                actors: [],
                hobbies: [],
                movies: [],
                sports: []
            }
            setstudentSignupDetails(newDetails)
            setIsDisabled(true)
            // console.log('this is it',newDetails);

        } else {
            if (localStorage.getItem('studentsignup1')) {
                setIsDisabled(false)
                setIsLoading(true);
                const districtLoad = localStorage.getItem('studentsignup1')
                    ? JSON.parse(localStorage.getItem('studentsignup1')).district
                    : "Jaffna";


                // axios.post(apiUrl, {
                axios.post(`${web_url}/api/auth/teachers/filter`, {
                    district: districtLoad
                })
                    .then((response) => {

                        const result = (response.data).reduce((acc, item) => {
                            const { school, userFullName, assignedClass } = item;
                            const grade = assignedClass.split("-")[0];
                            const classLetter = assignedClass.split("-")[1];

                            let schoolObj = acc.find((s) => s.school === school);

                            if (!schoolObj) {
                                schoolObj = { school, teachers: [] };
                                acc.push(schoolObj);
                            }

                            schoolObj.teachers.push({
                                teacherName: userFullName,
                                grade,
                                class: classLetter,
                            });

                            return acc;
                        }, []);
                        setSchoolObjectArray(result);
                        if (result.length === 0) {
                            handleClickOpenEmptyArray();
                        }
                        setIsLoading(false);
                    })
                    .catch((err) => {
                        setSchoolFetchError(err.message);
                        console.error("Error:", err.message);
                    });
            } else {
                navigate('/registerasstudent')
            }
        }
    }, []);

    const handleContinue = () => {
        console.log(selectedOptions);

        let newErrors = {};
        newErrors.noSchool = !studentSignupDetails.school;
        newErrors.noGrade = !studentSignupDetails.grade;
        newErrors.noClass = !studentSignupDetails.class;
        newErrors.noLanguage = !studentSignupDetails.languagePrefer;
        newErrors.noTeacher = !studentSignupDetails.teacher;

        if ((selectedOptions.some(option => option.label === 'Favourite actors')) || (selectedOptions.some(option => option.label === 'Favourite hobbies')) ||
            (selectedOptions.some(option => option.label === 'Favourite movies')) || (selectedOptions.some(option => option.label === 'Favourite sports'))
        ) {
            newErrors.noFavourites = false;
        } else {
            newErrors.noFavourites = true;
        }

        if (checked === false) {
            newErrors.noAgree = true;
        } else {
            newErrors.noAgree = false;
        }

        if ((selectedOptions.some(option => option.label === 'Favourite actors')) && studentSignupDetails.actors.length === 0) {
            newErrors.noActors = true
        } else {
            newErrors.noActors = false
        }

        if ((selectedOptions.some(option => option.label === 'Favourite hobbies')) && studentSignupDetails.hobbies.length === 0) {
            newErrors.noHobbies = true
        } else {
            newErrors.noHobbies = false
        }

        if ((selectedOptions.some(option => option.label === 'Favourite movies')) && studentSignupDetails.movies.length === 0) {
            newErrors.noMovies = true
        } else {
            newErrors.noMovies = false
        }

        if ((selectedOptions.some(option => option.label === 'Favourite sports')) && studentSignupDetails.sports.length === 0) {
            newErrors.noSports = true
        } else {
            newErrors.noSports = false
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        const studentDetails1 = localStorage.getItem('studentsignup1') ? JSON.parse(localStorage.getItem('studentsignup1')) : "Jaffna";


        const personalInterests = () => {
            const newPersonalInterests = {};

            if ((selectedOptions.some(option => option.label === 'Favourite sports')) && studentSignupDetails.sports && studentSignupDetails.sports.length > 0) {
                newPersonalInterests.sports = studentSignupDetails.sports;
            }

            if ((selectedOptions.some(option => option.label === 'Favourite hobbies')) && studentSignupDetails.hobbies && studentSignupDetails.hobbies.length > 0) {
                newPersonalInterests.hobbies = studentSignupDetails.hobbies;
            }

            if ((selectedOptions.some(option => option.label === 'Favourite actors')) && studentSignupDetails.actors && studentSignupDetails.actors.length > 0) {
                newPersonalInterests.actors = studentSignupDetails.actors;
            }

            if ((selectedOptions.some(option => option.label === 'Favourite movies')) && studentSignupDetails.movies && studentSignupDetails.movies.length > 0) {
                newPersonalInterests.movies = studentSignupDetails.movies;
            }

            return newPersonalInterests;
        };

        const student = {
            userEmail: studentDetails1.email.toLowerCase(),
            userPassword: studentDetails1.password,
            userFullName: studentDetails1.name,
            school: studentSignupDetails.school,
            grade: studentSignupDetails.grade,
            district: studentDetails1.district,
            assignedClass: `${studentSignupDetails.grade}-${studentSignupDetails.class}`,
            teacherName: studentSignupDetails.teacher,
            gender: studentDetails1.gender,
            ethnicity: studentDetails1.ethnicity,
            dateOfBirth: `${studentDetails1.dateOfBirth}`,
            preferredLanguage: studentSignupDetails.languagePrefer,
            personalInterests: personalInterests()
        };

        setIsLoading(true);
        const apiUrl = `${url}auth/students`;
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        axios.post(`${web_url}/api/auth/register/students`, student, config)
            .then((response) => {
                if (localStorage.getItem('userStatusDetails')) {
                    setMessage(t('t54_1'));
                    setIsLoading(false);
                    localStorage.removeItem('studentsignup1')
                    localStorage.removeItem('studentsignup2')
                    localStorage.removeItem('studentsignup3')
                    localStorage.removeItem('userStatusDetails')
                    handleClickOpen2();
                } else {
                    setIsLoading(false);
                    setMessage(t('t54_2'));
                    localStorage.removeItem('studentsignup1')
                    localStorage.removeItem('studentsignup2')
                    localStorage.removeItem('studentsignup3')
                    handleClickOpen2();
                }

            })
            .catch((err) => {
                console.log(err);
                if (err.response) {
                    if (err.response.data.error) {
                        handleClickOpenError(err.response.data.error);
                    } else if (err.response.data.message) {
                        handleClickOpenError(err.response.data.message);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
                setIsLoading(false);
            })



    }

    const languageArray = ['English', 'Sinhala', 'Tamil',];

    const [open, setOpen] = useState(false);
    const [checked, setChecked] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const [open2, setOpen2] = useState(false);
    const [message, setMessage] = useState("");

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('email is already taken')) {
            setError(t('t92'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        localStorage.removeItem('studentsignup1')
        localStorage.removeItem('studentsignup2')
        setOpenError(false);
        navigate('/registerasstudent')
    };

    const handleClose = () => {
        setChecked(false);
        setOpen(false);
    };

    const handleAgree = () => {
        setChecked(true);
        setOpen(false);
    };

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge  bg-no-repeat bg-cover min-h-screen w-screen flex flex-col justify-center pl-[30px] pr-[30px] md:items-center`}>
            <div className="fixed inset-0 bg-white/50 z-0"></div>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right z-20">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>

            <div className='relative  z-10'>
                <div className='flex flex-col justify-center h-full sm:w-full md:w-[400px] lg:w-[500px] xl:w-[750px] 2xl:w-[800px] pt-[50px]'>
                    <img src="/images/logo.svg" className="h-[100px] md:h-[130px] xl:h-[120px] 2xl:h-[130px]" alt='logo' />
                    <p className={`text-[#1E2533] text-center font-[600] leading-[27px] xl:leading-[30px] ${i18n.language === "en" ? "text-[21px] md:text-[23px] lg:text-[27px] xl:text-[27px] 2xl:text-[28px]" : (i18n.language === "si" ? "text-[17px] md:text-[22px] lg:text-[19px] xl:text-[22px] 2xl:text-[18px]" : "text-[16px] md:text-[19px] lg:text-[17px] xl:text-[20px] 2xl:text-[18px]")} mt-[20px]`}>{t('t358')}</p>
                    <p className={`text-[#1E2533] text-left font-[500] leading-[27px] xl:leading-[30px] ${i18n.language === "en" ? "text-[16px] md:text-[18px] lg:text-[21px] xl:text-[17px] 2xl:text-[20px]" : (i18n.language === "si" ? "text-[12px] md:text-[16px] lg:text-[13px] xl:text-[16px] 2xl:text-[12px]" : "text-[12px] md:text-[13px] lg:text-[13px] xl:text-[14px] 2xl:text-[13px]")} mt-[20px]`}>{t('t454')}</p>

                    <div className='flex flex-col xl:grid xl:grid-cols-3 xl:items-center xl:justify-center xl:gap-[20px] xl:w-full xl:items-stretch'>

                        <div className='h-full xl:w-full'>
                            <div className="items-center mt-[15px] flex h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px]">
                                <Menu as="div" className="w-full relative inline-block text-left py-[20px]">
                                    <div>
                                        <MenuButton
                                            className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px] text-[15px] md:text-[16px]  ${studentSignupDetails.languagePrefer === "" ? (i18n.language === "en" ? "text-gray-500 text-[15px] md:text-[17px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px]" : (i18n.language === "si" ? "text-gray-500 text-[10px] md:text-[17px] lg:text-[16px] xl:text-[13px] 2xl:text-[15px]" : "text-gray-500 text-[12px] md:text-[15px] lg:text-[16px] xl:text-[13px] 2xl:text-[15px]")) : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                                        >
                                            {studentSignupDetails.languagePrefer === "" ? t('t31') : studentSignupDetails.languagePrefer}
                                            <MdArrowDropDown
                                                aria-hidden="true"
                                                className="absolute right-[10px] size-8 text-gray-700"
                                            />
                                        </MenuButton>
                                    </div>

                                    <MenuItems
                                        transition
                                        className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                        style={{
                                            width: '100%',
                                            maxHeight: '120px',
                                            overflowY: 'auto'
                                        }}
                                    >
                                        <div className="py-1">
                                            {
                                                languageArray.map((languageSelect, index) => (
                                                    <MenuItem key={index}>
                                                        <button
                                                            className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                            onClick={() => {
                                                                setstudentSignupDetails((prev) => ({ ...prev, languagePrefer: languageSelect }))
                                                            }}
                                                        >
                                                            {languageSelect}
                                                        </button>
                                                    </MenuItem>
                                                ))
                                            }
                                        </div>
                                    </MenuItems>
                                </Menu>
                            </div>

                            {errors.noLanguage &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t32')}</p>
                            }
                        </div>

                        <div className='h-full xl:w-full xl:col-span-2'>
                            <div className="items-center mt-[15px] flex h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px]">
                                <Menu as="div" className="w-full relative inline-block text-left py-[20px]">
                                    <div >
                                        <MenuButton
                                            disabled={disabled}
                                            className={` truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px] text-[15px] ${studentSignupDetails.school === "" ? 'text-gray-500' : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                                        >
                                            <span className='md:hidden'>
                                                {studentSignupDetails.school === "" ? t('t33') : (studentSignupDetails.school.length > 28 ? studentSignupDetails.school.slice(0, 28) + '...' : studentSignupDetails.school)}
                                            </span>
                                            <span className='hidden md:block'>
                                                {studentSignupDetails.school === "" ? t('t33') : (studentSignupDetails.school.length > 38 ? studentSignupDetails.school.slice(0, 38) + '...' : studentSignupDetails.school)}
                                            </span>
                                            <MdArrowDropDown
                                                aria-hidden="true"
                                                className="absolute right-[10px] size-8 text-gray-700"
                                            />
                                        </MenuButton>
                                    </div>
                                    <MenuItems
                                        transition
                                        className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                        style={{
                                            width: '100%',
                                            maxHeight: '150px',
                                            overflowY: 'auto'
                                        }}
                                    >
                                        <div className="py-1">
                                            {
                                                schoolObjectArray.map((schoolSelect, index) => (
                                                    <MenuItem key={index}>
                                                        <button
                                                            className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                            onClick={() => {
                                                                setSchoolIndexSelected(index)
                                                                setstudentSignupDetails((prev) => ({
                                                                    ...prev, school: schoolSelect.school, teacher: "", class: "", grade: ""
                                                                }))
                                                            }}
                                                        >
                                                            {schoolSelect.school}
                                                        </button>
                                                    </MenuItem>
                                                ))
                                            }
                                        </div>
                                    </MenuItems>
                                </Menu>
                            </div>

                            {errors.noSchool &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t34')}</p>
                            }
                        </div>

                    </div>

                    <div className='flex flex-col xl:grid xl:grid-cols-4 xl:items-center xl:justify-center xl:gap-[20px] xl:w-full xl:items-stretch'>
                        <div className='h-full xl:w-full xl:col-span-2'>
                            <div className="items-center mt-[20px] flex h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px]">
                                <Menu as="div" className="w-full relative inline-block text-left py-[20px]">
                                    <div className='flex flex-col'>
                                        <MenuButton
                                            disabled={disabled || studentSignupDetails.school === ""}
                                            className={` truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px] text-[15px] ${studentSignupDetails.teacher === "" ? 'text-gray-500' : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                                        >
                                            <span className='md:hidden'>
                                                {studentSignupDetails.teacher === "" ? t('t3') : (studentSignupDetails.teacher.length > 28 ? studentSignupDetails.teacher.slice(0, 28) + '...' : studentSignupDetails.teacher)}
                                            </span>
                                            <span className='hidden md:block'>
                                                {studentSignupDetails.teacher === "" ? t('t3') : (studentSignupDetails.teacher.length > 38 ? studentSignupDetails.teacher.slice(0, 38) + '..' : studentSignupDetails.teacher)}
                                            </span>
                                            <MdArrowDropDown
                                                aria-hidden="true"
                                                className="absolute right-[10px] size-8 text-gray-700"
                                            />
                                        </MenuButton>
                                    </div>

                                    <MenuItems
                                        transition
                                        className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                        style={{
                                            width: '100%',
                                            maxHeight: '150px',
                                            overflowY: 'auto'
                                        }}
                                    >
                                        <div className="py-1">
                                            {
                                                schoolObjectArray[schoolIndexSelected]?.teachers?.map((teacherSelect, index) => (
                                                    <MenuItem key={index}>
                                                        <button
                                                            className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                            onClick={() => {
                                                                setstudentSignupDetails((prev) => ({ ...prev, teacher: teacherSelect.teacherName, class: teacherSelect.class, grade: teacherSelect.grade }))
                                                            }}
                                                        >
                                                            {teacherSelect.teacherName}
                                                        </button>
                                                    </MenuItem>
                                                ))
                                            }
                                        </div>
                                    </MenuItems>
                                </Menu>
                            </div>

                            {errors.noTeacher &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t39')}</p>
                            }
                        </div>

                        <div className='h-full xl:w-full'>
                            <div disabled={disabled} className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                <MdMenuBook size="24px" color="#8189B0" />
                                <input type="text" value={studentSignupDetails.grade} disabled name="grade" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t35')} />
                            </div>

                            {errors.noGrade &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t36')}</p>
                            }
                        </div>

                        <div className='h-full xl:w-full'>
                            <div disabled={disabled} className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                <MdGroup size="24px" color="#8189B0" />
                                <input type="text" value={studentSignupDetails.class} disabled name="class" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t37')} />
                            </div>

                            {errors.noClass &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t38')}</p>
                            }
                        </div>
                    </div>

                    <div>
                        <div className='items-center mt-[20px] flex rounded-md bg-[#F1F6FB] h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400'>
                            <Select
                                options={options}
                                isMulti
                                value={selectedOptions}
                                onChange={handleChange}
                                placeholder={t('t40_1')}
                                menuPortalTarget={document.body}
                                className="basic-multi-select w-full h-full"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 1000 }),
                                    control: (provided, state) => ({
                                        ...provided,
                                        background: '#F1F6FB',
                                        height: '100%', // Set height to fill the parent
                                        minHeight: 'unset', // Prevents the default minHeight from overriding
                                        border: 'none', // Removes react-select's default border
                                        boxShadow: 'none', // Removes the default box shadow
                                        padding: 0,
                                        outline: state.isFocused
                                            ? '2px solid #9CA3AF' // Outline color when focused
                                            : '1px solid #9CA3AF', // Default outline color
                                        outlineOffset: '-1px',
                                        borderRadius: '6px', // Match parent border radius
                                        transition: 'outline 0.2s ease',
                                        display: 'flex', // Ensures the items are aligned properly
                                    }),
                                    valueContainer: (provided) => ({
                                        ...provided,
                                        height: '100%', // Ensures the selected items take full height
                                        padding: '0 8px',
                                        display: 'flex', // Ensures items are displayed in a row
                                        flexWrap: 'nowrap', // Prevents wrapping of selected items
                                        overflowX: 'auto', // Enables horizontal scrolling
                                        gap: '4px', // Adds spacing between items
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: '#8189B0', // Placeholder text color
                                        fontSize: i18n.language === "en" ? '0.95rem' : "0.875rem", // Font size for placeholder
                                    }),
                                    multiValue: (provided) => ({
                                        ...provided,
                                        backgroundColor: '#E5E7EB', // Background color for selected items
                                        borderRadius: '4px',
                                        display: 'inline-flex', // Ensures inline display
                                        alignItems: 'center',
                                        padding: '0 4px',
                                        margin: '0', // Removes default margin
                                    }),
                                    multiValueLabel: (provided) => ({
                                        ...provided,
                                        color: '#111827', // Text color for selected items
                                        fontSize: '0.875rem',
                                    }),
                                    multiValueRemove: (provided) => ({
                                        ...provided,
                                        cursor: 'pointer',
                                        ':hover': {
                                            backgroundColor: '#D1D5DB', // Background color on hover
                                            color: '#111827',
                                        },
                                    }),
                                    indicatorsContainer: (provided) => ({
                                        ...provided,
                                        height: '100%', // Ensures the dropdown arrow takes full height
                                    }),
                                }}
                                classNamePrefix="select"
                            />
                        </div>
                        {errors.noFavourites &&
                            <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t40_6')}</p>
                        }


                        {
                            optionsVisible.Hobbies && <div className="mt-[15px]">
                                <>
                                    <Autocomplete
                                        multiple
                                        freeSolo
                                        id="tags-standard"
                                        options={[]}
                                        disableClearable
                                        value={studentSignupDetails.hobbies}
                                        onChange={(event, newValue, reason) => {
                                            if (reason === 'removeOption' || newValue.length <= 2) {
                                                handleChangeHobby(event, newValue, reason);
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder={t('t40_11')}
                                                label={t('t40_7')}
                                                variant="outlined"
                                                slotProps={{
                                                    htmlInput: {
                                                        ...params.inputProps,
                                                        readOnly: studentSignupDetails.hobbies.length >= 2,
                                                    },
                                                    inputLabel: {
                                                        color: '#6B7280',

                                                    }
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        fontFamily: 'Urbanist',
                                                        backgroundColor: '#F1F6FB',
                                                        borderRadius: 2,
                                                        '& fieldset': { borderColor: '#9CA3AF' },
                                                        '&:hover fieldset, &.Mui-focused fieldset': { borderColor: '#9CA3AF' },
                                                    },
                                                    '& input::placeholder': {
                                                        color: '#6B7280',
                                                        opacity: 1, // for consistent appearance in Firefox
                                                        fontSize: {
                                                            xs: i18n.language === 'en' ? '14px' : i18n.language === "si" ? '13px' : '13px',
                                                            sm: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '16px' : '16px',
                                                            md: i18n.language === 'en' ? '18px' : i18n.language === "si" ? '17px' : '17px',
                                                            lg: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '17px' : '15px',
                                                            xl: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '18px' : '18px'
                                                        },
                                                    },
                                                }}
                                            />
                                        )}
                                    />

                                    {errors.noHobbies &&
                                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t40_2')}</p>
                                    }
                                </>
                            </div>
                        }

                        {
                            optionsVisible.Actors && <div className="mt-[15px]">
                                <>
                                    <Autocomplete
                                        multiple
                                        freeSolo
                                        id="tags-standard"
                                        options={[]}
                                        disableClearable
                                        value={studentSignupDetails.actors}
                                        onChange={(event, newValue, reason) => {
                                            if (reason === 'removeOption' || newValue.length <= 2) {
                                                handleChangeActor(event, newValue, reason);
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder={t('t40_11')}
                                                label={t('t40_9')}
                                                variant="outlined"
                                                slotProps={{
                                                    htmlInput: {
                                                        ...params.inputProps,
                                                        readOnly: studentSignupDetails?.actors?.length >= 2,
                                                    },
                                                    inputLabel: {
                                                        color: '#6B7280',
                                                    }
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        fontFamily: 'Urbanist',
                                                        backgroundColor: '#F1F6FB',
                                                        borderRadius: 2,
                                                        '& fieldset': { borderColor: '#9CA3AF' },
                                                        '&:hover fieldset, &.Mui-focused fieldset': { borderColor: '#9CA3AF' },
                                                    },
                                                    '& input::placeholder': {
                                                        color: '#6B7280',
                                                        opacity: 1, // for consistent appearance in Firefox
                                                        fontSize: {
                                                            xs: i18n.language === 'en' ? '14px' : i18n.language === "si" ? '13px' : '13px',
                                                            sm: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '16px' : '16px',
                                                            md: i18n.language === 'en' ? '18px' : i18n.language === "si" ? '17px' : '17px',
                                                            lg: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '17px' : '15px',
                                                            xl: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '18px' : '18px'
                                                        },
                                                    },
                                                }}
                                            />
                                        )}
                                    />


                                    {errors.noActors &&
                                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t40_5')}</p>
                                    }
                                </>
                            </div>
                        }

                        {
                            optionsVisible.Sports && <div className="mt-[15px]">
                                <>
                                    <Autocomplete
                                        multiple
                                        freeSolo
                                        id="tags-standard"
                                        options={[]}
                                        disableClearable
                                        value={studentSignupDetails.sports}
                                        onChange={(event, newValue, reason) => {
                                            if (reason === 'removeOption' || newValue.length <= 2) {
                                                handleChangeSports(event, newValue, reason);
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder={t('t40_11')}
                                                label={t('t40_10')}
                                                variant="outlined"
                                                slotProps={{
                                                    htmlInput: {
                                                        ...params.inputProps,
                                                        readOnly: studentSignupDetails.sports.length >= 2,
                                                    },
                                                    inputLabel: {
                                                        color: '#6B7280',
                                                    }
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        fontFamily: 'Urbanist',
                                                        backgroundColor: '#F1F6FB',
                                                        borderRadius: 2,
                                                        '& fieldset': { borderColor: '#9CA3AF' },
                                                        '&:hover fieldset, &.Mui-focused fieldset': { borderColor: '#9CA3AF' },
                                                    },
                                                    '& input::placeholder': {
                                                        color: '#6B7280',
                                                        opacity: 1, // for consistent appearance in Firefox
                                                        fontSize: {
                                                            xs: i18n.language === 'en' ? '14px' : i18n.language === "si" ? '13px' : '13px',
                                                            sm: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '16px' : '16px',
                                                            md: i18n.language === 'en' ? '18px' : i18n.language === "si" ? '17px' : '17px',
                                                            lg: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '17px' : '15px',
                                                            xl: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '18px' : '18px'
                                                        },
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                    {errors.noSports &&
                                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t40_3')}</p>
                                    }
                                </>
                            </div>
                        }

                        {
                            optionsVisible.Movies && <div className="mt-[15px]">
                                <>
                                    <Autocomplete
                                        multiple
                                        freeSolo
                                        id="tags-standard"
                                        options={[]}
                                        disableClearable
                                        value={studentSignupDetails.movies}
                                        onChange={(event, newValue, reason) => {
                                            if (reason === 'removeOption' || newValue.length <= 2) {
                                                handleChangeMovie(event, newValue, reason);
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder={t('t40_11')}
                                                label={t('t40_8')}
                                                variant="outlined"
                                                slotProps={{
                                                    htmlInput: {
                                                        ...params.inputProps,
                                                        readOnly: studentSignupDetails.movies.length >= 2,
                                                    },
                                                    inputLabel: {
                                                        color: '#6B7280',
                                                    }
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        fontFamily: 'Urbanist',
                                                        backgroundColor: '#F1F6FB',
                                                        borderRadius: 2,
                                                        '& fieldset': { borderColor: '#9CA3AF' },
                                                        '&:hover fieldset, &.Mui-focused fieldset': { borderColor: '#9CA3AF' },
                                                    },
                                                    '& input::placeholder': {
                                                        color: '#6B7280',
                                                        opacity: 1,
                                                        fontSize: {
                                                            xs: i18n.language === 'en' ? '14px' : i18n.language === "si" ? '13px' : '13px',
                                                            sm: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '16px' : '16px',
                                                            md: i18n.language === 'en' ? '18px' : i18n.language === "si" ? '17px' : '17px',
                                                            lg: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '17px' : '15px',
                                                            xl: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '18px' : '18px'
                                                        },
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                    {errors.noMovies &&
                                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t40_4')}</p>
                                    }
                                </>
                            </div>
                        }
                    </div>

                    <div className='flex items-center justify-start mt-[20px]'>
                        <input type='checkbox' name='regulations'
                            checked={checked} onChange={handleClickOpen} />
                        <label className='text-[14px] text-black ml-[10px]'>{t('t46')}</label>
                    </div>
                    {errors.noAgree &&
                        <div className='items-center justify-start flex w-full'><p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t47')}</p></div>
                    }

                    <div className='w-full flex gap-[10px] items-center justify-center xl:justify-end pb-[30px]'>
                        <button onClick={() => { navigate('/studentpersonaldetails'); }} className={`${i18n.language === "en" ? "text-[18px] md:text-[18px] xl:text-[17px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[16px] md:text-[14px] xl:text-[14px] 2xl:text-[19px]" : "text-[16px] md:text-[14px] xl:text-[13px] 2xl:text-[18px]")} mt-[20px] rounded-lg pt-[10px] pb-[10px] w-full xl:w-[150px] hover:bg-opacity-80 text-[#EFAE03] bg-transparent border border-[#EFAE03] border-[2px] font-bold`}>{t('t455')}</button>
                        <button onClick={handleContinue} className={`${i18n.language === "en" ? "text-[18px] md:text-[18px] xl:text-[17px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[16px] md:text-[14px] xl:text-[14px] 2xl:text-[19px]" : "text-[16px] md:text-[14px] xl:text-[13px] 2xl:text-[18px]")} mt-[20px] rounded-lg pt-[10px] pb-[10px] w-full xl:w-[200px] hover:bg-opacity-80 text-white bg-[#EFAE03] font-bold`}>
                            {isLoading ? (
                                <div className="items-center justify-center flex">
                                    <div className='w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin'></div>
                                </div>
                            ) : (
                                t('t52')
                            )}
                        </button>
                    </div>

                    <Dialog
                        open={openEmptyArray}
                        onClose={handleClickOpenEmptyArray}
                        aria-labelledby="custom-dialog-title"
                        aria-describedby="custom-dialog-description"
                        className="backdrop-blur-sm"
                    >
                        <DialogTitle
                            id="custom-dialog-title"
                            className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                        >
                            ⚠️  {t('t48')}
                        </DialogTitle>
                        <DialogContent className="bg-gray-50">
                            <DialogContentText
                                id="custom-dialog-description"
                                className="text-gray-600 text-md mt-2"
                            >
                                {t('t98')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions className="px-4 py-2">
                            <Button
                                onClick={handleCloseEmptyArray}
                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                            >
                                {t('t13')}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={isLoading}
                        aria-labelledby="custom-dialog-title"
                        aria-describedby="custom-dialog-description"
                        className="backdrop-blur-sm"
                    >
                        <DialogContent className="bg-gray-50">
                            <DialogContent
                                id="custom-dialog-description"
                                className="text-gray-600 text-md mt-2"
                            >
                                <div className="items-center justify-center flex">
                                    <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                                </div>
                            </DialogContent>
                        </DialogContent>
                    </Dialog>

                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="custom-dialog-title"
                        aria-describedby="custom-dialog-description"
                        className="backdrop-blur-sm"
                    >
                        <DialogTitle
                            id="custom-dialog-title"
                            className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                        >
                            {t('t53')}
                        </DialogTitle>
                        <DialogContent className="bg-gray-50">
                            <p className='mt-[20px] text-black'>{t('t394')}</p>
                            <p className='mt-[20px] text-black'>{t('t395')}</p>
                            <p className='ml-[20px] text-black'>{t('t396')}</p>
                            <p className='mt-[20px] text-black'>{t('t397')}</p>
                            <p className='ml-[20px] text-black'>{t('t398')}</p>
                            <p className='mt-[20px] text-black'>{t('t399')}</p>
                            <p className='ml-[20px] text-black'>{t('t400')}</p>
                            <p className='mt-[20px] text-black'>{t('t401')}</p>
                            <p className='ml-[20px] text-black'>{t('t402')}</p>
                            <p className='mt-[20px] mb-[20px] text-black'>{t('t403')}</p>

                        </DialogContent>
                        <DialogActions className="px-4 py-2">
                            <Button
                                onClick={handleClose}
                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                            >
                                {t('t51')}
                            </Button>
                            <Button
                                onClick={handleAgree}
                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                            >
                                {t('t50')}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={open2}
                        onClose={handleClose2}
                        aria-labelledby="custom-dialog-title"
                        aria-describedby="custom-dialog-description"
                        className="backdrop-blur-sm"
                    >
                        <DialogContent className="bg-[#FFF6DA]">
                            {!isLoading &&
                                <DialogContent
                                    id="custom-dialog-description"
                                    className="text-gray-600 text-md mt-2"
                                >
                                    <div className='flex flex-col justify-center items-center text-center'>
                                        <img src='/images/success.svg' alt='success' />
                                        <div className='mt-[30px]'>{message}</div>
                                    </div>
                                </DialogContent>
                            }

                        </DialogContent>
                        <DialogActions
                            style={{
                                backgroundColor: '#FFF6DA',
                                display: 'flex',
                                justifyContent: 'center',
                                width: '100%',
                            }}
                        >
                            <Button
                                onClick={() => navigate('/loginas')}
                                style={{
                                    backgroundColor: '#F2AC0E',
                                    color: 'white',
                                    padding: '10px 20px', // px-4 py-2
                                    borderRadius: '0.375rem', // rounded-md
                                    fontWeight: 'bold',
                                }}
                            >
                                {t('t7')}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openError}
                        onClose={handleCloseError}
                        aria-labelledby="custom-dialog-title"
                        aria-describedby="custom-dialog-description"
                        className="backdrop-blur-sm"
                    >
                        <DialogTitle
                            id="custom-dialog-title"
                            className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                        >
                            {t('t95')}
                        </DialogTitle>
                        <DialogContent className="bg-gray-50">
                            <DialogContentText
                                id="custom-dialog-description"
                                className="text-gray-600 text-md mt-2"
                            >
                                {error}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions className="px-4 py-2">
                            <Button
                                onClick={handleCloseError}
                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                            >
                                {t('t96')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        </div>
    );
}

export default StudentSignUp2;